import { AxiosInstance } from 'axios'
import { endpoints } from '../api/constants'
import { PlatformAdmin } from '../types/Platform'
import { User, UserInformation } from '../types/User'

export type Identity = {
  userInfo?: UserInformation
  /** Why the client identity was rejected (no user row, suspended client…), if it was. */
  userError?: any
  platformAdmin?: PlatformAdmin
}

/**
 * Resolves both identities of the signed-in person in parallel: client user and platform
 * administrator. Either may be missing; a 404 from platform/me only means "not a platform admin".
 */
export const fetchIdentity = async (axios: AxiosInstance, signal?: AbortSignal): Promise<Identity> => {
  const [userResult, platformResult] = await Promise.allSettled([
    axios.get<UserInformation>(endpoints.getUserInfo, { signal }),
    axios.get<PlatformAdmin>(endpoints.platformMe, { signal }),
  ])

  const identity: Identity = {}

  if (userResult.status === 'fulfilled') {
    identity.userInfo = userResult.value.data
  } else {
    identity.userError = userResult.reason
  }

  if (platformResult.status === 'fulfilled') {
    identity.platformAdmin = platformResult.value.data
  }

  return identity
}

export const toUser = (userInfo: UserInformation): User => ({
  userid: userInfo.id,
  username: `${userInfo.firstName} ${userInfo.lastName}`,
  email: userInfo.email,
  imageurl: userInfo.imageUrl,
  isApprover: userInfo.isApprover,
  isAdmin: userInfo.isAdmin,
  client: userInfo.client,
})
